import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Sign In',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'Sign Up',
    component: () => import('../views/Registration.vue')
  },
  {
    name: 'admin creation panel',
    path: '/adm-create',
    component: () => import('../views/AdmCreation.vue')
  }, 
  //teams routes
  {
    path: '/team/profile',
    name: 'TeamProfile',
    component: () => import('../views/team/Profile.vue'),
    meta: { authRequired: true },
  },
  {
    path: '/team/decisions',
    name: 'TeamDecisions',
    meta: { authRequired: true },
    component: () => import('../views/team/Decisions.vue'), 
    children: [
      {path: 'products'}, 
      {path: 'sales'},
      {path: 'retail'}, 
      {path: 'promotion'}, 
      {path: 'resources'},
    ],
  },
  {//market reports for companies
    name: 'TeamMarket',
    path: '/team/market',
    meta: { authRequired: true },
    component: () => import('../views/team/Market.vue'),
    children: [
      {path: 'marketOverview'}, 
      {path: 'designReport'},
      {path: 'm&mReport'},
      {path: 'segmentsDescription'},
      {path: 'values'},
      {path: 'media'},
      {path: 'awareness&loyalty'},
      {path: 'products'},
      {path: 'retailReports'},
      {path: 'financialReports'},
      {path: 'hiddenNeeds'}
    ] 
  },
  {//reports for companies
    name: 'TeamReports',
    path: '/team/reports',
    meta: { authRequired: true },
    component: () => import('../views/team/Reports.vue'),
    children: [
      {path: 'sales'},
      {path: 'channelsSales'},
      {path: 'brandAwareness'},
      {path: 'loyalty'},
      {path: 'functionalExpansion'},
      {path: 'segmentSales'},
      {path: 'segmentsInsights'},
    ] 
  },
  //admin promo & universitiesadmin
  {
    name: 'admin panel promo',
    path: '/admin/promo',
   /*  meta: { authRequired: true }, */
    component: () => import('../views/admin/Promo.vue'),
    children: [
      {path: 'profile', name: 'admin.profile'}, 
      {path: 'institutes', name: 'admin.institutes'},
      {path: 'users', name: 'admin.users'},
    ]
  },
  {
    name: 'admin market',
    path: '/admin/market',
    meta: { authRequired: true },
    component: () => import('../views/admin/Market.vue'),
    children: [
      {path: 'segments', name: 'admin.segments'},
      {path: 'habits', name: 'admin.habits'},
      {path: 'values', name: 'admin.values'},
      {path: 'design', name: 'admin.design'},
      {path: 'materials', name: 'admin.materials'},
      {path: 'media', name: 'admin.media'},
      {path: 'features', name: 'admin.af'},
      {path: 'stories', name: 'admin.commertial.stories'},
      {path: 'insights', name: 'admin.commertial.insights'},
      {path: 'chains', name: 'admin.chains'},
    ]
  },
  {
    name: 'admin teams info',
    path: '/admin/teams',
    meta: { authRequired: true },
    component: () => import('../views/admin/Teams.vue'),
    children: [
      {path: 'teams', name: 'admin.teams.info'},
      {path: 'games', name: 'admin.teams.games'},
      {path: 'products', name: 'admin.teams.products'},
      {path: 'channels', name: 'admin.teams.channels'},
      {path: 'promotion', name: 'admin.teams.promotion'},
      {path: 'resources', name: 'admin.teams.resources'}
    ]
  },
  {
    name: 'admin summary',
    path: '/admin/summary',
    meta: { authRequired: true },
    component: () => import('../views/admin/Summary.vue'),
    children: [
      {path: 'franchise', name: 'admin.franchise'},
      {path: 'peakSize', name: 'admin.summary.peakSize'},
      {path: 'impact', name: 'admin.summary.impact'},
      {path: 'acceptance', name: 'admin.summary.acceptance'},
      {path: 'awareness', name: 'admin.summary.awareness'},
      {path: 'loyalty', name: 'admin.summary.loyalty'},
      {path: 'maxSales', name: 'admin.summary.maxSales'},
      {path: 'monthSales', name: 'admin.summary.monthSales'},
      {path: 'finishSales', name: 'admin.summary.finishSales'},
      {path: 'retailSales', name: 'admin.summary.retailSales'},
      {path: 'intermediary', name: 'admin.summary.intermediary'},
      {path: 'finances', name: 'admin.summary.finances'},
      {path: 'transition', name: 'admin.summary.transition'},
    ]
  },
  {//professor's profile 
    name: 'profile',
    path: '/professor/profile',
    meta: { authRequired: true },
    component: () => import('../views/professor/Profile.vue'),
  },
  {//professor's games 
    name: 'games',
    path: '/professor/games',
    meta: { authRequired: true },
    component: () => import('../views/professor/Game.vue'),
  },
  {//professor's create game 
    name: 'createGame',
    path: '/professor/create',
    meta: { authRequired: true },
    component: () => import('../views/professor/CreateGame.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _, next) => {
  const publicPages = ['/login', '/signup', '/adm-create', '/'];
  const authRequired = !publicPages.includes(to.path);
  const user = JSON.parse(localStorage.getItem('user'))?.user;
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !user) {
    next('/login');
  } else {
    next();
  }
});

export default router
